import React from 'react'
import Box from '../Box'
import Text from '../Text'
import Progress from '../Progress'

export default function ProgressIndicator({ message, progress, width = '100%', ease }) {
  return (
    <Box width="100%">
      <Text fontSize="small" color="neutral.1" mb="xsmall">
        {message}
      </Text>
      <Progress progress={progress} width={width} ease={ease} />
    </Box>
  )
}
